/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { FC, useState } from 'react';
import { useFolderContext } from '../../../contexts/FolderHistoryContext';
import { FolderContent } from '../../../types/FormTypes';
import axios from 'axios';
import styles from './fileTree.module.css';
import Image from 'next/image';
import { useOutputAreaContext } from '../../../contexts/OuputAreaContext';
import { BasicButton } from '../../shared/buttons/BasicButton';

type FileTreeProps = {
  contentID: string;
};
type FileTreeNodeProps = {
  folder: FolderContent;
  onFolderSelect: (folderId: string, name: string) => void;
  onFolderDoubleClick: (folderId: string) => void;
  selectedFolder: string;
};
const FileTreeNode: FC<FileTreeNodeProps> = ({
  folder,
  onFolderSelect,
  onFolderDoubleClick,
  selectedFolder,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { createFolder } = useFolderContext(); // Use the createFolder function from your context
  const [newFolderName, setNewFolderName] = useState('');
  const [isCreating, setIsCreating] = useState(false); // To toggle new folder input
  const isSelected = folder.id === selectedFolder ? true : false;
  const [subfolders, setSubfolders] = useState<FolderContent[]>();
  const [showSkeletons, setShowSkeletons] = useState(false);
  const [createTop, setCreateTop] = useState(false);

  const handleDoubleClick = () => {
    onFolderDoubleClick(folder.id); // Direct action on double-click, e.g., setting this folder for saving
  };

  const handleExpand = async (parentID: string, name: string) => {
    setIsExpanded(!isExpanded);
    onFolderSelect(parentID, name);
    if (!subfolders) {
      setShowSkeletons(true);
      const SF = await axios.post('/api/fileStructure/fetchFolders', parentID);
      const SFdata = SF.data as FolderContent[];
      setSubfolders(SFdata);
      setShowSkeletons(false);
    }
    // Optionally, lazy-load subfolders here
  };

  const handleCreateFolder = async (
    e: React.FormEvent<HTMLFormElement | HTMLImageElement>
  ) => {
    console.log('---handleCreateFolder---');
    e.preventDefault();
    if (!newFolderName.trim()) return;
    const newFolder = await createFolder(newFolderName, folder.id); // Pass the current folder's ID as the parent ID
    setSubfolders((prevSubfolders) => [
      ...(prevSubfolders || []),
      newFolder as unknown as FolderContent,
    ]);
    setNewFolderName('');
    setIsCreating(false);
    setIsExpanded(true); // Automatically expand to show the newly created folder
  };

  const highlight = isSelected ? 'selected' : 'unselected';
  const arrowImage = isExpanded
    ? '/icons/Arrow Chevron Down.svg'
    : '/icons/Arrow Chevron Forward.svg';

  const onImageClick = () => {
    const form = document.querySelector('form');
    if (form) {
      const fakeEvent = {
        preventDefault: () => {},
        currentTarget: form,
      };
      handleCreateFolder(fakeEvent as React.FormEvent<HTMLFormElement>);
    }
  };

  return (
    <div>
      <div
        onClick={() => handleExpand(folder.id, folder.name)}
        className={styles['flex-row-gap']}
      >
        <Image
          src={arrowImage}
          alt="Close"
          layout="fixed"
          objectFit="contain"
          height={18}
          width={18}
        />
        <div className={styles[highlight]}>{folder.name}</div>
      </div>
      {isExpanded && (
        <>
          <div style={{ paddingLeft: '20px' }}>
            {showSkeletons && (
              <div>
                <Image
                  src="/demoGifs/animation.gif"
                  alt="Close"
                  layout="fixed"
                  objectFit="contain"
                  height={30}
                  width={50}
                />
              </div>
            )}
            {!showSkeletons &&
              subfolders &&
              subfolders.map((subfolder) => (
                <div
                  key={subfolder.id}
                  className={styles['flex-row-gap-less-bottom-space']}
                >
                  {/* <Image
                    src="/icons/Arrow Chevron Forward.svg"
                    alt="Close"
                    layout="fixed"
                    objectFit="contain"
                    height={14}
                    width={14}
                  /> */}
                  <FileTreeNode
                    key={subfolder.id}
                    folder={subfolder}
                    onFolderSelect={onFolderSelect}
                    onFolderDoubleClick={onFolderDoubleClick}
                    selectedFolder={selectedFolder}
                  />
                </div>
              ))}
            {!showSkeletons && (
              <div className={styles['gap-top']}>
                {!isCreating && (
                  <div
                    className={styles['flex-row-gap-gray']}
                    onClick={() => {
                      setIsCreating(true);
                    }}
                  >
                    <Image
                      src="/icons/Actions Plus.svg"
                      alt="Close"
                      layout="fixed"
                      objectFit="contain"
                      height={16}
                      width={16}
                    />
                    <p>New Folder</p>
                  </div>
                )}
              </div>
            )}
            {isCreating && (
              <div className={styles['gap-bottom']}>
                <form
                  onSubmit={handleCreateFolder}
                  className={styles['flex-row-gap-form']}
                >
                  <input
                    type="text"
                    placeholder="New Folder"
                    value={newFolderName}
                    onChange={(e) => setNewFolderName(e.target.value)}
                    className={styles['input']}
                  />

                  <Image
                    src="/icons/Close X Gray.svg"
                    alt="Close"
                    layout="fixed"
                    objectFit="contain"
                    onClick={() => {
                      setIsCreating(false);
                    }}
                    height={14}
                    width={14}
                  />
                  <Image
                    src="/icons/CheckGray.svg" // Path to your submit button icon
                    alt="Create Sub-Level Folder"
                    role="button"
                    aria-label="Create Sub-Level Folder"
                    onClick={onImageClick}
                    layout="fixed"
                    objectFit="contain"
                    height={14}
                    width={14}
                  />
                </form>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export const FileTree: FC<FileTreeProps> = ({ contentID }) => {
  const { createFolder, folders, saveFileToFolder } = useFolderContext();
  const { setShowFileTree } = useOutputAreaContext();
  const [newTopLevelFolderName, setNewTopLevelFolderName] = useState('');
  const [selectedFolder, setSelectedFolder] = useState('');
  const [createTop, setCreateTop] = useState(false);
  const [selectedFolderId, setSelectedFolderId] = useState<string | null>(null);

  const textForButton = `Save to ${selectedFolder}`;

  const handleCreateTopLevelFolder = async (
    e: React.FormEvent<HTMLFormElement>
  ) => {
    console.log('---handleCreateTopFolder---');

    e.preventDefault();
    if (!newTopLevelFolderName.trim()) return;
    const newFolder = await createFolder(newTopLevelFolderName, null); // Pass null to indicate no parent folder (top-level)
    setNewTopLevelFolderName('');
    setCreateTop(false);
  };

  const folderSelected = (id: string, name: string) => {
    setSelectedFolderId(id); // Update the selected folder ID
    setSelectedFolder(name);
  };

  // Modify folders to include isSelected property before passing to FileTreeNode
  const foldersWithSelection = folders?.map((folder) => ({
    ...folder,
    isSelected: folder.id === selectedFolderId,
  }));

  const folderDoubleClicked = async (id: string) => {
    const save = await saveFileToFolder(id, contentID);
    setShowFileTree(false);
  };

  const onImageClick = () => {
    const form = document.querySelector('form');
    if (form) {
      const fakeEvent = {
        preventDefault: () => {},
        currentTarget: form,
      };
      handleCreateTopLevelFolder(fakeEvent as React.FormEvent<HTMLFormElement>);
    }
  };

  return (
    <div>
      <div className={styles['inner']}>
        {!folders && (
          <div>
            <p>There's no other folders created.</p>
          </div>
        )}
        <b>Create or select a folder location:</b>
        <div className={styles['space-below']}></div>
        {!createTop && (
          <div
            className={styles['flex-row-gap-gray']}
            onClick={() => {
              setCreateTop(true);
            }}
          >
            <Image
              src="/icons/Actions Plus.svg"
              alt="Close"
              layout="fixed"
              objectFit="contain"
              height={16}
              width={16}
            />
            <p>New Folder</p>
          </div>
        )}
        {createTop && (
          <div className={styles['gap-bottom']}>
            <form
              onSubmit={handleCreateTopLevelFolder}
              className={styles['flex-row-gap-form']}
            >
              <input
                type="text"
                placeholder="New Folder"
                value={newTopLevelFolderName}
                onChange={(e) => setNewTopLevelFolderName(e.target.value)}
                className={styles['input']}
              />
              <Image
                src="/icons/Close X Gray.svg"
                alt="Close"
                layout="fixed"
                objectFit="contain"
                onClick={() => {
                  setCreateTop(false);
                }}
                height={14}
                width={14}
              />
              <Image
                src="/icons/CheckGray.svg" // Path to your submit button icon
                alt="Create Top-Level Folder"
                role="button"
                aria-label="Create Top-Level Folder"
                onClick={onImageClick}
                layout="fixed"
                objectFit="contain"
                height={14}
                width={14}
              />
            </form>
          </div>
        )}
        {folders &&
          folders.map((folder) => (
            <div
              className={styles['flex-row-gap-bottom-space']}
              key={folder.id}
            >
              {/* <Image
                src="/icons/Arrow Chevron Forward.svg"
                alt="Close"
                layout="fixed"
                objectFit="contain"
                height={18}
                width={18}
              /> */}
              <FileTreeNode
                key={folder.id}
                folder={folder}
                onFolderSelect={folderSelected}
                onFolderDoubleClick={folderDoubleClicked}
                selectedFolder={selectedFolderId ?? ''}
              />
            </div>
          ))}
      </div>

      <div className={styles['save-button']}>
        <BasicButton
          theme="blue"
          type="button"
          text={textForButton}
          rightImage={{
            src: '/icons/ArrowRightWhite.svg',
            height: 24,
            width: 24,
          }}
          disabled={createTop || !selectedFolderId}
          onClick={async () => {
            await folderDoubleClicked(selectedFolderId ?? '');
          }}
          extraStyles={{
            border: '1px solid black',
            fontSize: '12px',
          }}
        />
      </div>
    </div>
  );
};
